import { Button, withStyles } from "@material-ui/core";
import { ArrowForward } from "@material-ui/icons";

const styles = (theme) => ({
  actionButton: {
    textTransform: "none",
    "&$actionDisabled": {
      backgroundColor: theme.headerIconColor,
      color: theme.TextColor,
      cursor: "not-allowed",
      opacity: 0.7,
    },
  },
  actionDisabled: {
    backgroundColor: theme.iconColor,
    color: "black",
  },
})
const NextButton = ({ onClick, disabled, classes }) => (
  <Button
    classes={{ root: classes.actionButton, disabled: classes.actionDisabled }}
    variant="contained"
    color="primary"
    onClick={onClick}
    disabled={disabled}
  >
    Move to Next Step <ArrowForward />
  </Button>
);

export default withStyles(styles)(NextButton);
